"use strict";
/* globals ga */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = require("@flowio/events");
var browser_helpers_1 = require("@flowio/browser-helpers");
var find_1 = __importDefault(require("lodash/find"));
var get_1 = __importDefault(require("lodash/get"));
var types_1 = require("../types");
var GoogleAnalytics = /** @class */ (function () {
    function GoogleAnalytics(options) {
        var defaultOpts = {
            useBaseCurrency: true,
            trackers: [],
        };
        var opts = __assign(__assign({}, defaultOpts), options);
        this.useBaseCurrency = opts.useBaseCurrency;
        this.customAttributes = opts.customAttributes;
        this.trackers = opts.trackers;
        var events = new events_1.ChannelEventEmitter();
        events.trigger('pixelGaReady');
    }
    GoogleAnalytics.test = function (global) {
        if (global === void 0) { global = window; }
        return (typeof global.ga === 'function');
    };
    GoogleAnalytics.configureTrackers = function (trackers) {
        if (!GoogleAnalytics.test()) {
            return;
        }
        trackers.forEach(function (tracker) {
            ga('create', tracker.tracker_id, 'auto', tracker.name);
            if (tracker.plugins.indexOf('ec') >= 0) {
                if (tracker.name != null) {
                    ga(tracker.name + ".require", 'ec');
                }
                else {
                    ga('require', 'ec');
                }
            }
        });
    };
    GoogleAnalytics.install = function (configuration) {
        var trackers = configuration.trackers;
        // Bail to avoid polluting global scope
        if (!trackers.length) {
            return;
        }
        if (GoogleAnalytics.test()) {
            GoogleAnalytics.configureTrackers(trackers);
            return;
        }
        window.GoogleAnalyticsObject = 'ga';
        var ga = window.ga = function () {
            ga.q.push(arguments);
        };
        ga.q = [];
        ga.l = +new Date();
        GoogleAnalytics.configureTrackers(trackers);
        browser_helpers_1.loadScript('https://www.google-analytics.com/analytics.js', {
            async: true,
        });
    };
    // FIXME: Losing benefits of type safety. We have declarations for GA which
    // can help identify potential data issues.
    GoogleAnalytics.prototype.fireEvent = function (command) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var ga = window.ga;
        var trackers = this.trackers;
        var isEnhancedEcommerce = command.indexOf('ec:') >= 0;
        if (typeof ga !== 'function') {
            return;
        }
        if (!trackers.length) {
            ga.apply(void 0, __spreadArrays([command], args));
            return;
        }
        trackers.filter(function (tracker) {
            return !isEnhancedEcommerce || tracker.plugins.indexOf('ec') >= 0;
        }).forEach(function (tracker) {
            var commandName = tracker.name != null ? tracker.name + "." + command : command;
            ga.apply(void 0, __spreadArrays([commandName], args));
        });
    };
    GoogleAnalytics.prototype.gaSetupEnhancedEcommercePlugin = function () {
        var _this = this;
        var ga = window.ga;
        var trackers = this.trackers;
        if (typeof ga !== 'function' || trackers.length) {
            return;
        }
        ga(function () {
            var tracker = ga.getByName('t0');
            if (tracker == null)
                return;
            // @ts-ignore
            var plugins = tracker.plugins_;
            if (plugins && Array.isArray(plugins.keys) && plugins.keys.indexOf('ec') >= 0) {
                return;
            }
            _this.fireEvent('require', 'ec');
        });
    };
    GoogleAnalytics.prototype.setCurrency = function (order) {
        var currency = this.useBaseCurrency ? order.total.base.currency : order.total.currency;
        this.fireEvent('set', 'currencyCode', currency);
    };
    GoogleAnalytics.prototype.fireAddToCart = function (item) {
        var data = {
            id: item.id,
            name: item.name,
            variant: item.variant,
            price: this.useBaseCurrency ? item.base_price : item.price,
            quantity: item.quantity,
            currency: this.useBaseCurrency ? item.base_currency : item.currency,
        };
        this.fireEvent('ec:addProduct', data);
        this.fireEvent('ec:setAction', 'add', { affiliation: 'Flow' });
        this.fireEvent('send', 'event', 'EnhancedEcommerce', 'button click', 'add to cart');
    };
    GoogleAnalytics.prototype.fireCheckoutStep = function (order, step) {
        var _this = this;
        this.gaSetupEnhancedEcommercePlugin();
        this.setCurrency(order);
        order.items.forEach(function (item) {
            var prices = get_1.default(item, 'local.prices', []);
            var itemPrice = find_1.default(prices, function (price) { return price.key === 'localized_item_price'; });
            var itemPriceAmount = _this.useBaseCurrency ? itemPrice.base.amount : itemPrice.amount;
            _this.fireEvent('ec:addProduct', {
                id: item.number,
                name: item.name,
                variant: '',
                price: itemPriceAmount,
                quantity: item.quantity,
            });
        });
        this.fireEvent('ec:setAction', 'checkout', { step: step, affiliation: 'Flow' });
        if (step === 1) {
            this.fireEvent('send', 'event', {
                eventAction: 'Started Order',
                eventCategory: 'EnhancedEcommerce',
            });
        }
        else if (step === 2) {
            this.fireEvent('send', 'event', {
                eventAction: 'Viewed Checkout - Shipping Page',
                eventCategory: 'EnhancedEcommerce',
            });
        }
        else if (step === 3) {
            this.fireEvent('send', 'event', {
                eventAction: 'Viewed Checkout - Payment Page',
                eventCategory: 'EnhancedEcommerce',
            });
        }
    };
    GoogleAnalytics.prototype.firePurchase = function (order) {
        var _this = this;
        this.gaSetupEnhancedEcommercePlugin();
        this.setCurrency(order);
        var shipping = order.prices.find(function (price) { return price.key === 'shipping'; });
        var shippingAmount = 0;
        if (shipping) {
            shippingAmount = this.useBaseCurrency ? shipping.base.amount : shipping.amount;
        }
        var vat = order.prices.find(function (price) { return price.key === 'vat'; });
        var vatAmount = 0;
        if (vat) {
            vatAmount = this.useBaseCurrency ? vat.base.amount : vat.amount;
        }
        order.items.forEach(function (item) {
            var prices = get_1.default(item, 'local.prices', []);
            var itemPrice = find_1.default(prices, function (price) { return price.key === 'localized_item_price'; });
            var itemPriceAmount = _this.useBaseCurrency ? itemPrice.base.amount : itemPrice.amount;
            _this.fireEvent('ec:addProduct', {
                id: item.number,
                name: item.name,
                variant: '',
                price: itemPriceAmount,
                quantity: item.quantity,
            });
        });
        this.fireEvent('ec:setAction', 'purchase', {
            id: order.number,
            affiliation: 'Flow',
            revenue: this.useBaseCurrency ? order.total.base.amount : order.total.amount,
            tax: vatAmount,
            shipping: shippingAmount,
        });
        this.fireEvent('send', 'event', { eventAction: 'Checkout Complete', eventCategory: 'EnhancedEcommerce' });
    };
    GoogleAnalytics.prototype.firePageView = function (value) {
        this.fireEvent('send', 'pageview', value);
    };
    /**
     * Update this pixel to report metrics to the specified trackers.
     */
    GoogleAnalytics.prototype.addTrackers = function (trackers) {
        GoogleAnalytics.configureTrackers(trackers);
        this.trackers = this.trackers.concat(trackers);
    };
    GoogleAnalytics.prototype.event = function (event) {
        switch (event.type) {
            case types_1.PixelEventType.PageView:
                this.firePageView(event.data.value);
                break;
            case types_1.PixelEventType.AddToCart:
                this.fireAddToCart(event.data.item);
                break;
            case types_1.PixelEventType.CheckoutInit:
                this.fireCheckoutStep(event.data.order, 1);
                break;
            case types_1.PixelEventType.CheckoutShipping:
                this.fireCheckoutStep(event.data.order, 2);
                break;
            case types_1.PixelEventType.CheckoutPayment:
                this.fireCheckoutStep(event.data.order, 3);
                break;
            case types_1.PixelEventType.Purchase:
            case types_1.PixelEventType.Transaction:
                this.firePurchase(event.data.order);
                break;
            case types_1.PixelEventType.GoogleCustomEvent:
                this.fireEvent('send', {
                    hitType: 'event',
                    eventCategory: event.data.category,
                    eventAction: event.data.action,
                    eventLabel: event.data.label,
                    eventValue: event.data.value,
                });
                break;
            default:
                break;
        }
    };
    return GoogleAnalytics;
}());
exports.default = GoogleAnalytics;



//////////////////
// WEBPACK FOOTER
// ./~/@flowio/pixel/dist/ga/googleAnalytics.js
// module id = 608
// module chunks = 0 1